<template>
  <div>
    <app-cells>
      <h1 class="title">Transfers</h1>
    </app-cells>
    <app-tabs v-if="show_tabs" :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'TransfersLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'transfers-upcoming', label: 'Upcoming' },
        { name: 'transfers-archive', label: 'Archive' },
      ]
    }
  },
  computed: {
    show_tabs() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('transfer_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('transfer_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
}
</script>
